// eslint-disable-next-line
export const SET_MENU_VISIBLE = 'SET_MENU_VISIBLE';
